module.exports = __webpack_public_path__ + "img/NEOS-alt.56f7f8c9.svg";